import { apolloClient } from './client';
import VueApollo from 'vue-apollo';

export const apolloProvider = new VueApollo({
	defaultClient: apolloClient
});